
// RelatorioComprasModal.js

import React, { useState } from 'react';
import { Modal, Typography, Button } from '@mui/material';
//import Axios from 'axios';
import api from '../config/axiosConfig';

import './RelatorioVendasModal.css';

const RelatorioComprasModal = ({ open, handleClose, idCompra, codCompra, codFor }) => {
  const [dataInicial, setDataInicial] = useState('');
  const [dataFinal, setDataFinal] = useState('');

  // Função para baixar o PDF
  const downloadPDF = (data, fileName) => {
    const blob = new Blob([data], { type: 'application/pdf' });
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = fileName;
    link.click();
  };

  // Função auxiliar para formatar datas de "yyyy-MM-dd" para "dd/MM/yyyy"
  const formatarData = (data) => {
    if (!data) return '';
    const partes = data.split('-');
    if (partes.length !== 3) return data; // Retorna como está se o formato for inesperado
    return `${partes[2]}/${partes[1]}/${partes[0]}`;
  };

  const handleImprimirCompraPagina = async () => {
    try {
      const response = await api.get('/compras/relatorio/pagina', {
        params: { idCompra }, // Usando o idCompra passado como prop
        responseType: 'blob'});
      // Nome do PDF já definido no backend, mas adicionamos o codcompra aqui
      downloadPDF(response.data, `Relatório da Compra ${codCompra}.pdf`);
    } catch (error) {
      console.error('Erro ao gerar relatório de compra da página', error);
    }
  };

  const handleImprimirComprasFornecedor = async () => {
    try {
      const response = await api.get('/compras/relatorio/fornecedor', {
        params: {
          codfor: codFor, // Use o código do fornecedorpassado como prop
          dataInicial: dataInicial,
          dataFinal: dataFinal},
        responseType: 'blob'
      });
      
      // Nome do PDF atualizado conforme o backend
      const fileName = `Relatório de Compras Cliente ${codFor} de ${formatarData(dataInicial)} a ${formatarData(dataFinal)}.pdf`;
      downloadPDF(response.data, fileName);
    } catch (error) {
      console.error('Erro ao gerar relatório de compras do cliente', error);
    }
  };

  const handleImprimirTodasCompras = async () => {
    try {
      const response = await api.get('/compras/relatorio/todos', {
        params: {
          dataInicial: dataInicial,
          dataFinal: dataFinal,
        },
        responseType: 'blob'
      });
      const fileName = `Relatório de Todas as Compras de ${formatarData(dataInicial)} a ${formatarData(dataFinal)}.pdf`;
      downloadPDF(response.data, fileName);
    } catch (error) {
      console.error('Erro ao gerar relatório de todas as compras', error);
    }
  };

  if (!open) return null;

  return (
    <Modal open={open} onClose={() => { 
        // Limpa os estados quando fechar o modal
        setDataInicial(''); 
        setDataFinal(''); 
        handleClose(); 
      }}>
      <div className="modal">
        <div className="modal-content">
          <span className="close" onClick={() => { 
              setDataInicial(''); 
              setDataFinal(''); 
              handleClose(); 
            }}>&times;</span>
          <Typography variant="h6" align="center">Imprimir Relatório de Compras</Typography>

          {/* Botão Compra Atual Centralizado */}
          <div className="button-center">
            <Button className="salvando" onClick={handleImprimirCompraPagina}>
              Compra Atual
            </Button>
          </div>

          {/* Seção de Período */}
          <Typography variant="subtitle1" className="periodo-title">
            Período:
          </Typography>
          <div className="date-container">
            <input
              type="date"
              value={dataInicial}
              onChange={(e) => setDataInicial(e.target.value)}
              className="date-input"
            />
            <input
              type="date"
              value={dataFinal}
              onChange={(e) => setDataFinal(e.target.value)}
              className="date-input"
            />
          </div>

          {/* Botões Compras Cliente e Todas as Compras Alinhados */}
          <div className="button-container">
            <Button 
              className="salvando" 
              onClick={handleImprimirComprasFornecedor}
              disabled={!dataInicial || !dataFinal || !codFor}
            >
              Compras Cliente
            </Button>
            <Button 
              className="salvando" 
              onClick={handleImprimirTodasCompras}
              disabled={!dataInicial || !dataFinal}
            >
              Todas Compras
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default RelatorioComprasModal;